import { combineReducers } from "redux";
import authReducer from "views/Login/reducers";
import userReducer from "views/User/reducers";
import userTypeReducer from "views/UserType/reducers";
import registerReducer from "views/Register/reducers";
import wilayahReducer from "views/Wilayah/reducers";
import portReducer from "views/Port/reducers";
import masterTrayekReducer from "views/MasterTrayek/reducers";
import depotReducer from "views/Depot/reducers";
import vesselReducer from "views/Vessel/reducers";
import animalTypeReducer from "views/AnimalType/reducers";
import animalReducer from "views/Animal/reducers";
import masterRatesReducer from "views/MasterRates/reducers";
import scheduleReducer from "views/Schedule/reducers";
import complaintReducer from "views/Complaint/reducers";
import actionReducer from "views/Action/reducers";
import aclReducer from "views/Acl/reducers";
import vesselTrackingReducer from "views/Dashboard/VesselTracking/reducers";
import orderPerBulanReducer from "views/Dashboard/OrderPerBulan/reducers";
import namaOperatorReducer from "views/Dashboard/NamaOperator/reducers";
import bookingReducer from "views/Booking/reducers";
import activityLogReducer from "views/ActivityLog/reducers";
import forgotPasswordReducer from "views/ForgotPassword/reducers";
import trackLogReducer from "views/TrackLog/reducers";
import manifestReducer from "views/Manifest/reducers";
import jadwalKapalReducer from "views/Dashboard/JadwalKapal/reducers";
import voyagePerTrayekReducer from "views/Dashboard/VoyagePerTrayek/reducers";
import realisasiReducer from "views/Dashboard/Realisasi/reducers";
import orderPerPortReducer from "views/Dashboard/OrderPerPort/reducers";
import waktuTempuhReducer from "views/Dashboard/WaktuTempuh/reducers";
import jenisMuatanPerPrioritasReducer from "views/Dashboard/JenisMuatanPerPrioritas/reducers";
import muatanPerWilayahReducer from "views/Dashboard/MuatanPerWilayah/reducers";
import muatanPerWilayahPerPrioritasReducer from "views/Dashboard/MuatanPerWilayahPerPrioritas/reducers";
import orderPerJenisPrioritasReducer from "views/Dashboard/OrderPerJenisPrioritas/reducers";
import realisasiMuatanPerOperatorReducer from "views/Dashboard/RealisasiMuatanPerOperator/reducers";
import sisaQuotaTrayekReducer from "views/Dashboard/SisaQuotaTrayek/reducers";
import animalPerPortReducer from "views/Dashboard/AnimalPerPort/reducers";
import trackingDataReducer from "views/TrackingData/reducers";
import dokterReducer from "views/Dokter/reducers";
import dataHewanReducer from "views/Schedule/data_hewan/reducers";
import beritaAcaraReducer from "views/Schedule/berita_acara/reducers";
import masterTarifReducer from "views/MasterTarif/reducers";
import hargaJualReducer from "views/HargaJual/reducers";
import kontrakReducer from "views/Kontrak/reducers";
import eodReducer from "views/Eod/reducers";

import animalListReducer from "views/Dashboard/AnimalList/reducers";
import disparitasHargaReducer from "views/Dashboard/DisparitasHarga/reducers";
import poReducer from "views/Dashboard/PO/reducers";
import masterKodeTrayekReducers from "views/MasterKodeTrayek/reducers";

const reducers = combineReducers({
    auth: authReducer,
    users: userReducer,
    userType: userTypeReducer,
    register: registerReducer,
    wilayah: wilayahReducer,
    port: portReducer,
    masterTrayek: masterTrayekReducer,
    masterTarif: masterTarifReducer,
    hargaJual: hargaJualReducer,
    depot: depotReducer,
    vessel: vesselReducer,
    animalType: animalTypeReducer,
    animal: animalReducer,
    masterRates: masterRatesReducer,
    schedule: scheduleReducer,
    complaint: complaintReducer,
    action: actionReducer,
    acl: aclReducer,
    vesselTracking: vesselTrackingReducer,
    orderPerBulan: orderPerBulanReducer,
    namaOperator: namaOperatorReducer,
    booking: bookingReducer,
    activityLog: activityLogReducer,
    forgotPassword: forgotPasswordReducer,
    trackLog: trackLogReducer,
    manifest: manifestReducer,
    jadwalKapal: jadwalKapalReducer,
    voyagePerTrayek: voyagePerTrayekReducer,
    realisasi: realisasiReducer,
    orderPerPort: orderPerPortReducer,
    waktuTempuh: waktuTempuhReducer,
    jenisMuatanPerPrioritas: jenisMuatanPerPrioritasReducer,
    muatanPerWilayah: muatanPerWilayahReducer,
    muatanPerWilayahPerPrioritas: muatanPerWilayahPerPrioritasReducer,
    orderPerJenisPrioritas: orderPerJenisPrioritasReducer,
    realisasiMuatanPerOperator: realisasiMuatanPerOperatorReducer,
    sisaQuotaTrayek: sisaQuotaTrayekReducer,
    animalPerPort: animalPerPortReducer,
    trackingData: trackingDataReducer,
    dokter: dokterReducer,
    dataHewan: dataHewanReducer,
    beritaAcara: beritaAcaraReducer,
    kontrak: kontrakReducer,
    eod: eodReducer,

    animalList: animalListReducer,
    disparitasHarga: disparitasHargaReducer,
    PO: poReducer,
    masterKodeTrayek: masterKodeTrayekReducers,
});

export default reducers;
